export default __webpack_public_path__ + "static/media/dashboard-upload.3740d683.svg";